<template>
  <router-view/>
</template>

<style>
</style>

<script>
  import page_bg from '@/components/page_bg'
  import wx from "weixin-js-sdk";
  import axios from "axios";

  // const baseURL="http://47.112.219.35:9981/insurance"
  const baseURL="http://www.wanbaoe.cn:9981/insurance"
  var shareTitle="限时5天，惊喜不停"
  var shareContent="摩博会专属福利，点击看看~"
  let api=require("./api/index")
  export default {

    data () {
      return {
        share:null
      }
    },

    components: {
      page_bg
    },

    methods: {
      init(){
        let _this=this
        let _url=window.location.href
        axios.post(baseURL+'/motoci/13/applyWXShareConfig_elc?page='+_url).then(function (res) {
          console.log(res)
          _this.share=res.data.data
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: _this.share.appid, // 必填，公众号的唯一标识
            timestamp: _this.share.timestamp, // 必填，生成签名的时间戳
            nonceStr: _this.share.nonce_str, //  必填，生成签名的随机串
            signature: _this.share.signature,// 必填，签名
            jsApiList: ["updateAppMessageShareData","updateTimelineShareData","onMenuShareTimeline","onMenuShareAppMessage","onMenuShareQQ"] // 必填，需要使用的JS接口列表
          })
          wx.ready(function () {
            wx.updateAppMessageShareData({
              title:shareTitle, // 分享标题
              desc: shareContent, // 分享描述
              link: _this.share.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _this.share.shareImg, // 分享图标
              success: function () {
              },
              fail:function (res) {
                console.log(res)
              }
            })
            wx.updateTimelineShareData({
              title:shareTitle, // 分享标题
              link: _this.share.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _this.share.shareImg, // 分享图标
              success: function () {
              },
              fail:function (res) {
                console.log(res)
              }
            })
            wx.onMenuShareQQ({
              title:shareTitle, // 分享标题
              desc: shareContent, // 分享描述
              link:  _this.share.shareUrl,
              imgUrl: _this.share.shareImg, // 分享图标
              success: function () {
                // 用户确认分享后执行的回调函数
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              },
              fail:function (res) {
                console.log(res)
              }
            })
          })
        })
      },
    },

    mounted () {
      this.init()
    },
    created() {

    }
  }
</script>
